import { Datagrid, ListProps, TextField } from 'react-admin';
import { CustomList, MediaField, SortableDatagridBody } from '../../components';
import ActiveField from '../../components/ActiveField';

export default function TimelineItemsList(props: ListProps) {
  return (
    <CustomList
      {...props}
      filter={{
        $limit: -1,
        $sort: 'position'
      }}
      pagination={false}
    >
      <Datagrid body={<SortableDatagridBody />} rowClick="edit">
        <MediaField label="Ícone" source="icon" sortable={false} />

        <TextField label="Ano" source="year" sortable={false} />

        <TextField label="Título" source="title" sortable={false} />

        <ActiveField label="Ativo" />
      </Datagrid>
    </CustomList>
  );
}
